import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import "katex/dist/katex.min.css";

/**
 * MathText — render a string that may contain KaTeX math wrapped in `$…$`
 * (inline) or `$$…$$` (block).
 *
 * Split rule: `$$block$$` first, then `$inline$`. Non-math chunks stay as
 * plain text so labels like "Speed = $\frac{d}{t}$ m/s" render correctly.
 *
 * Failing math snippets fall back to their raw source so we never crash the
 * page on a bad AI output.
 */
export default function MathText({ text = "", className = "" }) {
  if (!text) return null;
  // Split preserving both `$$…$$` and `$…$` segments.
  const parts = String(text).split(/(\$\$[^$]+\$\$|\$[^$]+\$)/g).filter(Boolean);
  return (
    <span className={className}>
      {parts.map((p, i) => {
        if (p.startsWith("$$") && p.endsWith("$$")) {
          const inner = p.slice(2, -2).trim();
          try { return <BlockMath key={i} math={inner} />; }
          catch { return <span key={i}>{p}</span>; }
        }
        if (p.startsWith("$") && p.endsWith("$")) {
          const inner = p.slice(1, -1).trim();
          try { return <InlineMath key={i} math={inner} />; }
          catch { return <span key={i}>{p}</span>; }
        }
        return <span key={i}>{p}</span>;
      })}
    </span>
  );
}
